// Моковые данные для детальной страницы зарплаты
export const getMockSalaryDetailData = (selectedDepartment, selectedMonth) => {
  // Генерируем моковые данные для сотрудников (соответствуют макету)
  const employees = [
    {
      id: 1,
      name: "Иванов И.",
      salary: 300000,
      paid: 300000,
      remaining: 0,
      timesheet: {
        workingDays: 21,
        weekendsAndHolidays: 8,
        daysWorked: 21,
        workingHours: 168,
        hoursWorked: 168,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
      moneyCosts: {
        hoursWorked: 300000,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
    },
    {
      id: 2,
      name: "Иванов И.",
      salary: 270000,
      paid: 0,
      remaining: 270000,
      timesheet: {
        workingDays: 21,
        weekendsAndHolidays: 8,
        daysWorked: 19, // меньше рабочих дней - будет красный крестик
        workingHours: 168,
        hoursWorked: 150,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 2,
      },
      moneyCosts: {
        hoursWorked: 270000,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
    },
    {
      id: 3,
      name: "Иванов И.",
      salary: 264275,
      paid: 264275,
      remaining: 0,
      timesheet: {
        workingDays: 21,
        weekendsAndHolidays: 8,
        daysWorked: 15,
        workingHours: 168,
        hoursWorked: 120,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 3,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 3,
        absences: 0,
      },
      moneyCosts: {
        hoursWorked: 264275,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
    },
    {
      id: 4,
      name: "Иванов И.",
      salary: 328571,
      paid: 300000,
      remaining: 28571,
      timesheet: {
        workingDays: 21,
        weekendsAndHolidays: 8,
        daysWorked: 23, // больше рабочих дней - будет желтый треугольник
        workingHours: 126,
        hoursWorked: 147,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
      moneyCosts: {
        hoursWorked: 328571,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
    },
    {
      id: 5,
      name: "Иванов И.",
      salary: 285713,
      paid: 200000,
      remaining: 85713,
      timesheet: {
        workingDays: 21,
        weekendsAndHolidays: 8,
        daysWorked: 12, // меньше рабочих дней - будет красный крестик
        workingHours: 168,
        hoursWorked: 96,
        businessTrips: 0,
        annualLeave: 8,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
      moneyCosts: {
        hoursWorked: 285713,
        businessTrips: 0,
        annualLeave: 0,
        unpaidLeave: 0,
        maternityLeave: 0,
        studyLeave: 0,
        sickLeave: 0,
        absences: 0,
      },
    },
  ];

  // Вычисляем итоговые суммы
  const totalAmount = employees.reduce((sum, emp) => sum + emp.salary, 0);
  const paidAmount = employees.reduce((sum, emp) => sum + emp.paid, 0);
  const remainingAmount = employees.reduce((sum, emp) => sum + emp.remaining, 0);

  return {
    departmentName: selectedDepartment?.label || "Архитектурный отдел ОЗ",
    employeeCount: employees.length,
    employees,
    totalAmount,
    paidAmount,
    remainingAmount,
  };
};


